import { useId, type ComponentProps } from 'preact/compat'

interface InputProps extends ComponentProps<'input'> {
  label?: string
  error?: string
  helperText?: string
  containerClassName?: string
}

export function Input({
  label,
  error,
  helperText,
  containerClassName = '',
  className = '',
  id,
  type = 'text',
  disabled,
  ...props
}: InputProps) {
  const inputId = id ?? useId()

  return (
    <div className={`space-y-1.5 ${containerClassName}`}>
      {label && (
        <label htmlFor={inputId} className='block text-body-sm text-gray-700'>
          {label}
        </label>
      )}

      <input
        id={inputId}
        type={type}
        disabled={disabled}
        className={`
          w-full px-4 py-2.5 text-sm text-gray-900 bg-white border rounded-2xl
          transition-colors duration-200
          focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cencert-navy-blue-light focus:border-transparent
          ${
            error
              ? 'border-red-500 focus:ring-red-500'
              : 'border-gray-300 hover:border-gray-400'
          }
          ${
            disabled
              ? 'bg-gray-50 text-gray-500 cursor-not-allowed opacity-50'
              : ''
          }
          ${className}
        `}
        {...props}
      />

      {error && <p className='text-sm text-red-600'>{error}</p>}

      {helperText && !error && (
        <p className='text-sm text-gray-500'>{helperText}</p>
      )}
    </div>
  )
}
